import { Component, ViewEncapsulation } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { NgbModal, NgbTooltipConfig } from "@ng-bootstrap/ng-bootstrap"
import { NotificationsService } from "angular2-notifications"
import { PendoService } from "./services/pendo.service"
import { UserService } from "./services/user.service"
import { AuthModalComponent } from "./shared-components/modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "./shared-components/modals/student-login-modal/student-login-modal.component"
import { redirectToError } from "./utils/error-handling"
import Utils from "./utils/utils"

declare var window: any

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.less"],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private modalService: NgbModal,
        private userService: UserService,
        private notificationService: NotificationsService,
        private pendoService: PendoService,
        private tooltipConfig: NgbTooltipConfig
    ) {
        window.PBSLM.browser = {
            ie: Utils.isIEBrowser(),
            safari: Utils.isSafari(),
            edge: Utils.isEdgeBrowser(),
        }
        if (window.PBSLM.ERROR_CODE) {
            redirectToError(this.router, window.PBSLM.ERROR_CODE)
            window.PBSLM.ERROR_CODE = null
            return
        }

        this.configureTooltip()
    }

    public ngOnInit() {
        this.userService.runOnceForQueryParam(this.activeRoute, "login", () => {
            if (!this.userService.isLoggedIn()) {
                if (this.userService.hasStudentExperience()) {
                    this.modalService.open(StudentLoginModalComponent)
                } else {
                    this.modalService.open(AuthModalComponent)
                }
            }
        })
        this.pendoService.initialize()
    }

    public onActivate() {
        window.scroll(0, 0)
        this.preventEmbedCycles()
        this.showServerSetMessages()
    }

    private preventEmbedCycles() {
        if (
            window.top !== window.self &&
            window.top.location.host === window.location.host
        ) {
            /* The current application is embeded in an iframe, aka "double header bug", most likely due to an
             * old site navigation issue. We want to load the most recent viewed page in the top browser window.
             * We also, only want to do this the current application is embedded on the same domain.
             */
            window.top.location.href = window.self.location.href
        }
    }

    private showServerSetMessages() {
        if (window.PBSLM.NG.MESSAGES) {
            window.PBSLM.NG.MESSAGES.forEach((item) => this.showMessage(item))
            window.PBSLM.NG.MESSAGES = null
        }
    }

    private showMessage(messageItem) {
        const params = { timeOut: 10000, showProgressBar: false }
        let type
        if (messageItem.tags.indexOf("error") !== -1) {
            type = "error"
        } else if (messageItem.tags.indexOf("success") !== -1) {
            type = "success"
        } else if (messageItem.tags.indexOf("warn") !== -1) {
            type = "warn"
        } else {
            type = "info"
        }
        this.notificationService.html(messageItem.message, type, params)
    }

    private configureTooltip() {
        this.tooltipConfig.triggers = "hover"
        this.tooltipConfig.openDelay = 300
        this.tooltipConfig.container = "body"
    }
}
